import React from "react";
import { useTranslation } from "react-i18next";

import { TextInput } from "@common/textInput";
import { Props } from "./types";
import { LanguageSelection } from "./languageSelection";
import styles from "./styles.scss";

function matchDefaultLang(defaultLang: string) {
  return (
    ["fr", "en"].find((lang) => new RegExp(lang).test(defaultLang)) || "fr"
  );
}

function NameInput({ value, input, autoFocus }: Props) {
  const { t, i18n } = useTranslation();
  const [currentTab, setCurrentTab] = React.useState(
    matchDefaultLang(i18n.language),
  );

  return (
    <div className={styles.nameInput}>
      <div className={styles.group}>
        <p className={styles.label}>
          {t("secondaryCriteriaTemplate.form.name.label")}
        </p>
        <TextInput
          value={value.name}
          placeholder={t("secondaryCriteriaTemplate.form.name.placeholder")}
          maxLength={256}
          input={(name) => input({ ...value, name })}
          autoFocus={autoFocus}
        />
      </div>
      <div className={styles.group}>
        <p className={styles.label}>
          {t("secondaryCriteriaTemplate.form.name.translations")}
        </p>
        <LanguageSelection
          selectedLanguage={currentTab}
          editLanguage={setCurrentTab}
        />
        <TextInput
          value={
            value.labels[currentTab as keyof typeof value.labels] ||
            value.labels.fr
          }
          placeholder={value.name}
          input={(label) =>
            input({
              ...value,
              labels: { ...value.labels, [currentTab]: label },
            })
          }
        />
      </div>
    </div>
  );
}

export { NameInput };
